import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import Laoding from '../shared/Laoding';


export default function SoftwareLogin(props) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [properLink, setProperLink] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const targetRef1 = useRef(null);
    const [searchParams] = useSearchParams();
    const target = searchParams.get("target");
    const contractno = searchParams.get("contractno");
    const token = searchParams.get("token");
    const otherSystemIdentity = searchParams.get("otherSystemIdentity");

    useEffect(() => {
        var params = {token:token, contractNo:parseInt(contractno)};
        var url = config.Server+`/user/software/login/check`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                console.log("response is>", response);
                util.deleteOtherSystemDetail();
                util.saveOtherSystemDetail(otherSystemIdentity, "", "", "", "", "");
                
                var user = response;
                var ExpireTime = new Date().getTime() / 1000;
                ExpireTime += (30 * 60 * 1000);
                user["ExpireTime"] = ExpireTime;
                util.setCurrentUser(user);
                util.saveSoftwareTargetContractNo(contractno)
                var afterLogin = "/my-contracts/list";
                if(target == util.SoftwareUrlTypes.Ticket){
                    afterLogin = "/ticket/client";
                }
                else if(target == util.SoftwareUrlTypes.Recontinue){                    
                    afterLogin = "/my-contracts/list";
                }
                else if(target == util.SoftwareUrlTypes.Upgrade){
                    afterLogin = "/my-contracts/list";
                }
                setProperLink(afterLogin);
                console.log("after login is>", afterLogin);
                
                if(props.onLoggedIn)props.onLoggedIn();                                        
                setLoading(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setLoading(false);
            }
        })
        .catch(error => {
            console.log("error is>", error)
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLoading(false);
        });
    }, []);

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :        
        loading?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    <Laoding showLable={true} label="در حال احراز هویت..." />
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        properLink == ""?
        <>
            <Row>
                <Col className="d-flex justify-content-center align-items-center" style={{height:"calc(100vh - 70px)"}}>
                    عدم موفقيت در احراز هویت
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px"}} ref={targetRef1}>
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px", textAlign:"center"}}>
                        احراز هویت با موفقیت انجام گردید
                        <br/><br/>
                        <Button severity="success" onClick={()=>{setRedirectUrl(properLink)}} style={{borderRadius:"5px", width:"100px"}} iconPos="right" icon="pi pi-check">&nbsp;&nbsp;&nbsp;&nbsp;ادامه&nbsp;&nbsp;&nbsp;&nbsp;</Button>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}